/*!
 * devextreme-angular
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

import { NestedOption } from 'devextreme-angular-rpk/core';


export abstract class DxoHtmlEditorTableResizing extends NestedOption {
    get enabled(): boolean {
        return this._getOption('enabled');
    }
    set enabled(value: boolean) {
        this._setOption('enabled', value);
    }

    get minColumnWidth(): number {
        return this._getOption('minColumnWidth');
    }
    set minColumnWidth(value: number) {
        this._setOption('minColumnWidth', value);
    }

    get minRowHeight(): number {
        return this._getOption('minRowHeight');
    }
    set minRowHeight(value: number) {
        this._setOption('minRowHeight', value);
    }
}
